import { styled } from '@mui/material/styles';

const StyledTableHeader = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.25rem;
  padding: 0 0.25rem;

  h1 {
    margin: 0;
    font-size: 1.6rem;
    font-weight: 700;
    color: #1841ff;
    letter-spacing: -0.01em;
  }
`;

export default StyledTableHeader;
